export default "__VITE_ASSET__CWYuBwAx__"